import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "./queryKeys";
import {
  EventType,
  getEventTypes,
} from "~/lib/server-functions/get-event-types";

export const useEventTypes = (ids?: number[] | string[]) => {
  // Check if the array contains numbers or strings
  const isNames = ids && ids.length > 0 && typeof ids[0] === "string";

  return useQuery<EventType[]>({
    queryKey: [QUERY_KEYS.EVENT_TYPES, ids],
    queryFn: async () => {
      if (isNames) {
        const eventTypes = await getEventTypes({
          data: { names: ids as string[] },
        });
        return eventTypes;
      } else {
        const eventTypes = await getEventTypes({
          data: ids ? { ids: ids as number[] } : undefined,
        });
        return eventTypes;
      }
    },
  });
};
